import type { ClientId, EquipmentId, InspectionId, ProfessionalId } from "../../shared/kernel/identifiers.js";

export type InspectionModality = 'INTERNAL' | 'EXTERNAL' | 'GENERAL';

export type InspectionNature = 'INITIAL' | 'PERIODIC' | 'EXTRAORDINARY';

export type InspectionStatus = 'DRAFT' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';

export interface Inspection {
  id: InspectionId;
  clientId: ClientId;
  equipmentId: EquipmentId;
  equipmentSnapshotId: string | null; // Will map to DocumentSnapshotId from documents
  projectId?: string | null;
  unitAreaId?: string | null;
  workOrderId?: string | null;
  subWorkOrderId?: string | null;
  operationalCondition?: string | null;
  inspectionType: string;
  modality: InspectionModality;
  nature: InspectionNature;
  extraordinaryReason: string | null;
  startDate: string;
  endDate: string | null;
  inspectorId: ProfessionalId;
  notes: string | null;
  status: InspectionStatus;

  version: number;
  createdAt: string;
  updatedAt: string;
}

export function validateInspectionNature(nature: InspectionNature, reason: string | null): void {
  if (nature === 'EXTRAORDINARY' && (!reason || reason.trim().length === 0)) {
    throw new Error('Extraordinary inspection requires a reason');
  }
}
